export const SAVE_SELECT_GOODS = 'SAVE_SELECT_GOODS' // 存储选中的商品信息

export const DELETE_SELECT_GOODS = 'DELETE_SELECT_GOODS' // 删除选中信息

export const UPDATE_SELECT_GOODS = 'UPDATE_SELECT_GOODS' // 更新选中商品

export const CLEAR_SELECT_GOODS = 'CLEAR_SELECT_GOODS' // 清空选中的商品

export const SAVE_SELECT_STORE = 'SAVE_SELECT_STORE' // 保存选中的门店

export const JUDGE_GET_GOOD_LIST = 'JUDGE_GET_GOOD_LIST' // 判断是否可以获取存储的商品信息

export const SAVE_GROUP_BUY_CONTENT = 'SAVE_GROUP_BUY_CONTENT' // 保存活动文本内容

export const SAVE_GROUP_BUY_ACTIVITY = 'SAVE_GROUP_BUY_ACTIVITY' // 保存活动内容

export const SAVE_GROUP_BUY_ACTIVITY_STORE_INFO = 'SAVE_GROUP_BUY_ACTIVITY_STORE_INFO' // 保存活动门店id

export const CLEAR_GROUP_BUY_ALL_INFO = 'CLEAR_GROUP_BUY_ALL_INFO' // 清空所有信息

export const SET_GROUPBUY_ACTIVITY_STATE = 'SET_GROUPBUY_ACTIVITY_STATE' // 活动列表tab状态

export const SET_GROUPBUY_DETAIL_ACTIVITY_STATE = 'SET_GROUPBUY_DETAIL_ACTIVITY_STATE' // 活动详情状态

export const SET_IS_BACK_GENERAL_CODE = 'SET_IS_BACK_GENERAL_CODE' // 订单页是否从扫码点单核销页返回的
